<template>
	<div class="left_option mgb_10">
		<em class="lt_text">Item {{ headers.class }}</em>
		<span class="int_type" style="width:550px;">
			<!-- <autocomplete ref="ac" :initialDisplay="keyword" :source="selectClasses" @selected="selectClass" results-display="code_name" placeholder="Item / Class Name or Code"> </autocomplete> -->
			<AC
				ref="ac"
				:initialDisplay="keyword"
				:source="selectClasses"
				:multiSelect="multiSelect"
				:bfSelectedList="itemClasses"
				:bfSelectedList_prop="'code'"
				@selected="selectClass"
				@unselected="unselectClass"
				results-display="code_name"
				:placeholder="'Item / ' + headers.class + ' Name or Code'"
			/>
		</span>
		<span class="int_type_no_border mgr_5" v-if="!hideClassesString">
			<ItemClassSelectMulti v-model.trim="item_classes_string" @input="changeValue" />
		</span>
	</div>
</template>
<script>
import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';
import AC from '@/components/common/AC';

export default {
	name: 'ItemClassSelectMultiS',
	props: {
		value: {
			type: [Array, String],
		},
		multiSelect: {
			type: Boolean,
			default: false,
		},
		includeClosedYn: {
			type: String,
			default: null,
		},
		hideClassesString: {
			type: Boolean,
			default: false,
		},
		classCodeToAdd: {
			type: String,
			default: null,
		},
		// value가 null인 경우 type이 String인지 Array인지 알 수 없으므로 value의 type이 String일 때 명식적으로 true를 할당
		syncWithString: {
			type: Boolean,
			default: false,
		},
	},
	data: function() {
		return {
			keyword: null,
			item_classes_string: null,
		};
	},
	components: {
		ItemClassSelectMulti,
		AC,
	},
	watch: {
		classCodeToAdd: {
			immediate: true,
			handler() {
				if (!this.classCodeToAdd) return;

				if (this.item_classes_string) this.item_classes_string += ',' + this.classCodeToAdd;
				else this.item_classes_string = this.classCodeToAdd;

				this.update();
			},
		},
	},
	computed: {
		itemClasses: function() {
			let string = this.item_classes_string;
			if (string) {
				return string.trim().split(',');
			} else {
				return [];
			}
		},
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	methods: {
		selectClasses(input) {
			let uri = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
			if (this.includeClosedYn) uri += '&include_closed_yn=' + this.includeClosedYn;
			return uri;
		},
		selectClass(c) {
			if (this.item_classes_string) this.item_classes_string += ',' + c.selectedObject.code;
			else this.item_classes_string = c.selectedObject.code;
			this.update();
		},
		unselectClass(c) {
			const copyItemClasses = [...this.itemClasses];
			const idx = copyItemClasses.findIndex(cls => cls === c.selectedObject.code);
			if (idx > -1) {
				copyItemClasses.splice(idx, 1);
				this.item_classes_string = copyItemClasses.join(',');
				this.update();
			}
		},
		changeValue() {
			this.update();
		},
		reset() {
			this.keyword = null;
			this.item_classes_string = null;
			this.update();
		},
		update() {
			this.$emit('input', this.syncWithString ? this.item_classes_string : this.itemClasses);
		},
	},
	created() {
		if (this.value) {
			this.item_classes_string = this.syncWithString ? this.value : this.value.join(',');
		}
	},
};
</script>
